import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { useSupportStore } from "@/stores/supoort"
import { Authorization } from "@/services/authenticate";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationSettingsView',
  setup(__props) {

const support = useSupportStore();

async function assignMandatory() {
  await support.assingMandatoryProjects(Authorization.id);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Mandatory projects", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("span", null, "Check and assign any missing mandatory projects for all users", -1)),
    _createElementVNode("div", { class: "buttons" }, [
      _createElementVNode("button", {
        onClick: assignMandatory,
        class: "accent",
        title: "If some user is missing any of the mandatory projects, click this button"
      }, "Check & Assign")
    ])
  ]))
}
}

})